import { SortInput } from '@apeiron/common'
import {
  OrbitalTrackFilterInput,
  OrbitalTrackSortBy,
  OrbitalTrackSortItems
} from '@apeiron/orbital'
import { Box, styled } from '@mui/material'
import ListTemplate from '@src/components/layout/ListTemplate'
import OrbitalTrackFilter from '@src/components/orbitalTrack/list/filter/OrbitalTrackFilter'
import PublicOrbitalTrackDataGrid from '@src/components/orbitalTrack/list/marketplace/PublicOrbitalTrackDataGrid'
import SortDropdown from '@src/components/share/generic/SortDropdown'
import useOrbitalTrackFilterQuery from '@src/hooks/apeiron/orbitalTrack/useOrbitalTrackFilterQuery'
import * as R from 'ramda'
import { FC, ReactNode, useCallback } from 'react'

const Template = styled(ListTemplate)`
  .Custom-Layout-Container {
    .Custom-Main-Panel {
      .Custom-Main-Container {
        max-width: 1700px;
      }
    }
  }
`

const Dropdown = styled(SortDropdown<OrbitalTrackSortBy>)`
  max-width: 200px;
  width: 100%;
  height: 100%;
`

const Filter = styled(OrbitalTrackFilter)`
  ${props => props.theme.breakpoints.up('res1024')} {
    height: calc(100vh - 116px);
    top: 116px;
  }
  width: 100%;
`

const DataGrid = styled(PublicOrbitalTrackDataGrid)`
  min-height: 820px;
`

const OrbitalTrackMarketplace: FC<Props> = props => {
  const { allowFetch, thirdNavBar } = props

  const { filterInput, sortInput, setBothInput, setFilterInput } =
    useOrbitalTrackFilterQuery()

  const handleOnFilterChange = useCallback(
    (filter: OrbitalTrackFilterInput, sort?: SortInput<OrbitalTrackSortBy>) => {
      if (R.isNotNil(filter) && R.isNotNil(sort)) {
        setBothInput(filter, sort)
      } else {
        setFilterInput(filter)
      }
    },
    [setBothInput, setFilterInput]
  )

  const handleOnSortChange = useCallback(
    (input: SortInput<OrbitalTrackSortBy>) => {
      setBothInput(filterInput, input as SortInput<OrbitalTrackSortBy>)
    },
    [filterInput, setBothInput]
  )

  return (
    <Template
      thirdNavBar={thirdNavBar}
      filter={
        <Filter
          filterInput={filterInput}
          sortInput={sortInput}
          onFilterChange={handleOnFilterChange}
        />
      }
      headerLeft={<Box />}
      sortDropDown={
        <Dropdown
          items={OrbitalTrackSortItems}
          value={sortInput}
          onSelectChange={handleOnSortChange}
        />
      }
      mainContent={
        allowFetch ? (
          <DataGrid filterInput={filterInput} sortInput={sortInput} />
        ) : (
          <></>
        )
      }
    />
  )
}

type Props = {
  allowFetch: boolean
  thirdNavBar?: ReactNode
}

export default OrbitalTrackMarketplace
